export default {
    V4_ID_PATTERN: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx',
    V4_ID_REGEX: /[xy]/g,
    VENDORS: {
        APPLE: 'Apple',
    },
    DEVICE_VALIDATOR: /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
};
//# sourceMappingURL=devices.constants.js.map